import { DecimalPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { ShoppingApiService } from '../../../services/apis/shopping-api.service';
import { ApiException, ApiStatus } from '../../../services/apis/status';
import { CartService } from '../../../services/cart.service';
import { Button } from '../../common/button/button';

@Component({
  selector: 'app-shopping-cart-checkout',
  imports: [DecimalPipe, Button, MatIconModule],
  templateUrl: './shopping-cart-checkout.html',
  styleUrl: './shopping-cart-checkout.scss',
})
export class ShoppingCartCheckout {
  constructor(
    private cartService: CartService,
    private shoppingApi: ShoppingApiService,
    private router: Router
  ) {}

  loading: boolean = false;
  get subtotal(): number {
    return this.cartService.subtotal();
  }

  async checkout() {
    try {
      this.loading = true;
      const r = await this.shoppingApi.createPaymentIntent();
      this.router.navigate(['checkout', r.id]);
    } catch (error) {
      if (error instanceof ApiException) {
        if (error.status === ApiStatus.SHOPPING_CART_EMPTY) {
          this.cartService.findShoppingCartItems();
        }
      }
    } finally {
      this.loading = false;
    }
  }
}
